import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LadingNote } from 'src/app/work-orders/work-order-details/work-order.interfaces';
import { ModalConfig } from '../../models/modal-system.interfaces';

export type DynamicGridUpdateTarget = {
  table: string;
  column: string;
  primary_key?: string;
  match_column?: string;
  scope_column?: string;
};

export type DynamicGridConfigItem = {
  db_field: string;
  input_type: string;
  is_visible: boolean;
  header_name: string;
  is_editable: boolean;
  is_sortable?: boolean;
  display_order?: number;
  modal_config?: ModalConfig;
  update_target?: DynamicGridUpdateTarget;
};

export type DynamicGridResponse = {
  success: boolean;
  config: DynamicGridConfigItem[];
  data: any[];
  message?: string;
  code?: number;
};

export type IdentityScope = 'carrier' | 'customer' | 'shipper' | 'consignee';

export type DynamicContactAccessContactProfile = {
  contact_uuid: string;
  profile_type: number | null;
  contact_organization: string;
};

export type DynamicContactAccessContactListResponse = {
  contact_profiles?: DynamicContactAccessContactProfile[];
  message?: string;
  code?: number | string;
};

export type DynamicGridUpdatePayload = {
  action: 'update_cell';
  entity_target: string;
  identity_scope: IdentityScope;
  contact_uuid?: string;
  row_uuid: string;
  db_field: string;
  new_value: any;
  update_target?: DynamicGridUpdateTarget;
};

@Injectable({
  providedIn: 'root'
})
export class CarrierOrdersGridService {
  private readonly gridEndpoint = '/api/dynamic_grids/contact_dynamic_work_order.php';
  private readonly contactAccessListEndpoint = '/api/dynamic_grids/dynamic_contact_access_contact_list.php';

  constructor(private http: HttpClient) {}

  getContactOrgForUser(): Observable<string> {
    return this.http.get<string>(`/api/users/user_organization_uuid.php`);
  }

  getDynamicWorkOrdersGrid(
    entity_target: string = 'work_orders',
    identity_scope: IdentityScope = 'carrier',
    contact_uuid?: string,
  ): Observable<DynamicGridResponse> {
    let params = new HttpParams()
      .set('request_type', 'grid_data')
      .set('entity_target', entity_target)
      .set('identity_scope', identity_scope);

    if (contact_uuid) {
      params = params.set('contact_uuid', contact_uuid);
    }

    return this.http.get<DynamicGridResponse>(this.gridEndpoint, { params });
  }

  getDynamicContactAccessContactList(profileType: number): Observable<DynamicContactAccessContactListResponse> {
    const params = new HttpParams().set('profile_type', String(profileType));
    return this.http.get<DynamicContactAccessContactListResponse>(this.contactAccessListEndpoint, { params });
  }

  updateDynamicWorkOrderCell(payload: DynamicGridUpdatePayload): Observable<any> {
    return this.http.post<any>(this.gridEndpoint, payload);
  }

  getLadingNotes(uuid: string): Observable<LadingNote[]> {
    return this.http.get<LadingNote[]>(`path_to_script_here.php?uuid=${encodeURIComponent(uuid)}`);
  }
}
